import spiderman from '@/spiderman/index';

async function get(member) {
  return (
    await spiderman.axios.get(spiderman.api.inboxes, {
      headers: {
        jwt: member.jwt,
      },
      params: {
        twid: member.info.twid,
        birthdate: member.info.birthdate,
      },
    })
  ).data;
}

async function removeMany(member, _ids) {
  return (
    await spiderman.axios.delete(spiderman.api.inboxes, {
      headers: {
        jwt: member.jwt,
      },
      data: {
        _ids,
      },
    })
  ).data;
}

export default {
  get,
  removeMany,
};
